<div class="d-flex flex-column gap-2 font-sm">
    @for (message of sortedMessages(); track message.id) {
        <div
            class="d-flex w-100"
            [ngClass]="{
                'justify-content-start': message.from === 'Customer',
                'justify-content-end': message.from !== 'Customer',
            }"
        >
            @if (message.from === 'Customer') {
                <span
                    class="badge rounded-pill text-bg-panel me-2 weight-normal font-sm"
                >
                    C
                </span>
            }

            <div
                class="d-flex mw-60 flex-column gap-2"
                [ngClass]="{
                    'justify-content-start': message.from === 'Customer',
                    'justify-content-end': message.from !== 'Customer',
                }"
            >
                @for (attachment of message.attachments; track $index) {
                    @if (previewable(attachment)) {
                        <div
                            class="p-1 rounded"
                            [ngClass]="messageClass(message)"
                        >
                            <telxl-shared-content-preview-inline
                                [file]="attachment"
                            />
                            <telxl-shared-single-attachment
                                [file]="file(attachment)"
                            />
                        </div>
                    } @else {
                        <div
                            class="p-1 rounded"
                            [ngClass]="messageClass(message)"
                        >
                            <telxl-shared-single-attachment
                                [file]="file(attachment)"
                            />
                        </div>
                    }
                }

                @if (message.messageBody && message.messageBody.length > 0) {
                    <div class="p-1 rounded" [ngClass]="messageClass(message)">
                        {{ message.messageBody.trim() }}
                    </div>
                }
            </div>

            @if (message.from === 'Bot') {
                <span
                    class="badge border border-bot text-bot ps-1 rounded-pill ms-2 weight-normal font-sm"
                >
                    <i class="fa-light fa-robot"></i>
                </span>
            }
            @if (message.from === 'agent' || message.from === 'Agent') {
                <span
                    class="badge rounded-pill ms-2 weight-normal font-sm"
                    [ngClass]="agentMessageClass()"
                >
                    A
                </span>
            }
        </div>
    }
</div>
